import React, { useContext } from "react";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import { UserContext } from "../../context/UserContext";
import xplanLabels from "../../util/XplanLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import GroupApprovers from "../FieldTags/GroupApprovers";
import { checkRole } from "../../util/FormUtils";

const newPlan = window.location.pathname === "/xplans/new";

const CertificateOfDestructionRequired = ({ certificateOfDestructionRequired, handleChange, xplans, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, ROLES.ELEVATED);

    return (
        <div id="certificateOfDestructionRequired" className="planField">
            <GroupApprovers />
            <FormControl>
                <FormLabel className="planRadioTitle" required={required.includes("certificateOfDestructionRequired")}>
                    {xplanLabels.certificateOfDestructionRequired}
                </FormLabel>
                <RadioGroup
                    name="certificateOfDestructionRequired"
                    label={xplanLabels.certificateOfDestructionRequired}
                    value={certificateOfDestructionRequired}
                    onChange={(e) => handleChange("certificateOfDestructionRequired", e.target.value)}
                    row
                >
                    <FormControlLabel
                        value="Yes"
                        control={<Radio disabled={!canEdit} />}
                        label="Yes"
                    />
                    <FormControlLabel
                        value="No"
                        control={<Radio disabled={!canEdit} />}
                        label="No"
                    />
                </RadioGroup>
            </FormControl>
            {!newPlan && <HistoryLogElement xplans={xplans} label={"certificateOfDestructionRequired"} /> }
        </div>
    );
};

export default CertificateOfDestructionRequired;